import * as React from "react";
import { Icon } from "./icon";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
import { LoadingSpinner } from "./loadingspinner";
const reButtonClass = css({
    display: "inline-block",
    borderRadius: "4px 4px 4px 4px",
    backgroundRepeat: "no-repeat",
    cursor: "pointer",
    textAlign: "center",
    whiteSpace: "nowrap",
    outline: "none",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "7px 16px",
    borderWidth: "1px",
    borderStyle: "solid",
    i: {
        fontSize: "24px",
        marginRight: "7px",
    },
    ".revo-loading-spinner": {
        marginRight: "7px",
    },
});
const reButtonSmallClass = css({
    fontSize: "14px",
    padding: "3px 10px",
    i: {
        marginRight: "5px",
        fontSize: "20px",
    },
    ".revo-loading-spinner": {
        marginRight: "5px",
    },
});
const reButtonTinyClass = css({
    fontSize: "12px",
    lineHeight: "20px",
    i: {
        marginRight: "5px",
        fontSize: "20px",
        lineHeight: "20px",
    },
    ".revo-loading-spinner": {
        marginRight: "5px",
    },
});
const reButtonTinyPaddingClass = css({
    padding: "1px 4px",
});
const reButtonShadowClass = css({
    boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.2)",
});
const primaryCssColorProps = {
    backgroundColor: getThemeColorVar("primary", "default"),
    color: getThemeColorVar("white", undefined),
    borderColor: getThemeColorVar("primary", "default"),
};
const primaryDisabledCssColorProps = {
    "&:disabled": {
        backgroundColor: getThemeColorVar("disabled", "default"),
        borderColor: getThemeColorVar("disabled", "default"),
    },
};
const disabledCursorCssProps = {
    "&:disabled": {
        cursor: "default",
    },
};
const primaryClass = css(primaryCssColorProps, primaryDisabledCssColorProps, disabledCursorCssProps);
const primaryDangerClass = css({
    backgroundColor: getThemeColorVar("negative", "default"),
    borderColor: getThemeColorVar("negative", "default"),
});
const primaryInvertedCssColorProps = {
    color: getThemeColorVar("primary", "default"),
    backgroundColor: getThemeColorVar("white", undefined),
    borderColor: getThemeColorVar("white", undefined),
};
const primaryInvertedDisabledCssColorProps = {
    "&:disabled": {
        color: getThemeColorVar("disabled", "default"),
        backgroundColor: getThemeColorVar("white", undefined),
        borderColor: getThemeColorVar("white", undefined),
    },
};
const primaryInvertedClass = css(primaryInvertedCssColorProps, primaryInvertedDisabledCssColorProps, disabledCursorCssProps);
const primaryInvertedDangerClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    color: getThemeColorVar("negative", "default"),
    borderColor: getThemeColorVar("white", undefined),
});
const secondaryCssColorProps = {
    backgroundColor: "Transparent",
    color: getThemeColorVar("primary", "default"),
    borderColor: getThemeColorVar("primary", "default"),
};
const secondaryDisabledCssColorProps = {
    "&:disabled": {
        color: getThemeColorVar("disabled", "default"),
        borderColor: getThemeColorVar("disabled", "default"),
    },
};
const secondaryClass = css(secondaryCssColorProps, secondaryDisabledCssColorProps, disabledCursorCssProps);
const secondaryDangerClass = css({
    color: getThemeColorVar("negative", "default"),
    borderColor: getThemeColorVar("negative", "default"),
});
const tertiaryCssColorProps = {
    backgroundColor: "Transparent",
    color: getThemeColorVar("primary", "default"),
};
const tertiaryCssOtherProps = {
    fontSize: "14px",
    border: 0,
    padding: 0,
};
const tertiaryDisabledCssColorProps = {
    "&:disabled": {
        color: getThemeColorVar("disabled", "default"),
    },
};
const tertiaryClass = css(tertiaryCssColorProps, tertiaryCssOtherProps, tertiaryDisabledCssColorProps, disabledCursorCssProps);
const tertiaryInvertedCssColorProps = {
    color: getThemeColorVar("primary", "inverted"),
    backgroundColor: "Transparent",
    fontSize: "14px",
};
const tertiaryInvertedCssOtherProps = css({
    border: 0,
    padding: 0,
});
const tertiaryInvertedClass = css(tertiaryInvertedCssColorProps, tertiaryInvertedCssOtherProps);
const tertiaryDangerClass = css({
    color: getThemeColorVar("negative", "default"),
});
const linkClass = css({
    "&:hover, &:focus, &:active": {
        outline: 0,
        textDecoration: "none",
    },
});
const smallIconClass = css({
    paddingLeft: "5px",
});
const smallOnlyIconClass = css({
    paddingLeft: "5px",
    paddingRight: "5px",
    i: {
        marginRight: 0,
    },
    ".revo-loading-spinner": {
        marginRight: 0,
    },
});
const iconClass = css({
    paddingLeft: "7px",
});
const onlyIconClass = css({
    paddingLeft: "7px",
    paddingRight: "7px",
    i: {
        marginRight: 0,
    },
    ".revo-loading-spinner": {
        marginRight: 0,
    },
});
const loadingClass = css({
    opacity: 0.7,
    cursor: "not-allowed",
});
function buildTypeClasses({ type, inverted, danger }) {
    const typeProps = [];
    switch (type) {
        case "primary":
            if (inverted) {
                typeProps.push(primaryInvertedClass);
                if (danger) {
                    typeProps.push(primaryInvertedDangerClass);
                }
            }
            else {
                typeProps.push(primaryClass);
                if (danger) {
                    typeProps.push(primaryDangerClass);
                }
            }
            break;
        case "secondary":
            typeProps.push(secondaryClass);
            if (danger) {
                typeProps.push(secondaryDangerClass);
            }
            break;
        case "tertiary":
            if (inverted) {
                typeProps.push(tertiaryInvertedClass);
            }
            else {
                typeProps.push(tertiaryClass);
            }
            if (danger) {
                typeProps.push(tertiaryDangerClass);
            }
            break;
    }
    return typeProps;
}
function buildSizeClasses({ size, type }) {
    const classes = [];
    if (size == "small") {
        classes.push(reButtonSmallClass);
    }
    else if (size == "tiny") {
        classes.push(reButtonTinyClass);
        if (type === "primary" || type === "secondary")
            classes.push(reButtonTinyPaddingClass);
    }
    return classes;
}
function buildShadowClasses({ shadow }) {
    if (shadow) {
        return [reButtonShadowClass];
    }
    return [];
}
function buildIconClasses({ type, icon, size, children, }) {
    const classes = [];
    if (type !== "tertiary") {
        if (icon && React.Children.count(children) === 0) {
            if (size == "small" || size == "tiny") {
                classes.push(smallOnlyIconClass);
            }
            else {
                classes.push(onlyIconClass);
            }
        }
        else if (icon) {
            if (size == "small" || size == "tiny") {
                classes.push(smallIconClass);
            }
            else {
                classes.push(iconClass);
            }
        }
    }
    return classes;
}
function buildLoadingClasses({ type, inverted, danger, loading, }) {
    if (!loading) {
        return [];
    }
    if (type === "primary" && inverted && danger) {
        const overridingClass = css({ "&:disabled": primaryInvertedDangerClass });
        return [loadingClass, overridingClass];
    }
    if (type === "primary" && danger) {
        const overridingClass = css({ "&:disabled": primaryDangerClass });
        return [loadingClass, overridingClass];
    }
    if (type === "primary" && inverted) {
        const overridingClass = css({ "&:disabled": primaryInvertedClass });
        return [loadingClass, overridingClass];
    }
    if (type === "primary") {
        const overridingClass = css({ "&:disabled": primaryCssColorProps });
        return [loadingClass, overridingClass];
    }
    if (type === "secondary" && danger) {
        const overridingClass = css({ "&:disabled": secondaryDangerClass });
        return [loadingClass, overridingClass];
    }
    if (type === "secondary") {
        const overridingClass = css({ "&:disabled": secondaryClass });
        return [loadingClass, overridingClass];
    }
    if (type === "tertiary" && danger) {
        const overridingClass = css({ "&:disabled": tertiaryDangerClass });
        return [loadingClass, overridingClass];
    }
    if (type === "tertiary") {
        const overridingClass = css({ "&:disabled": tertiaryCssColorProps });
        return [loadingClass, overridingClass];
    }
    return [loadingClass];
}
function renderIcon(props) {
    if (props.loading) {
        return (React.createElement(LoadingSpinner, { alignLeft: true, size: props.size == "small" || props.size == "tiny" ? 20 : 24, color: props.danger ? "negative" : "primary", inverted: props.type === "primary" && !props.inverted }));
    }
    else if (props.icon) {
        return React.createElement(Icon, { name: props.icon });
    }
    else {
        return undefined;
    }
}
export const Button = (props) => {
    const classes = [reButtonClass].concat(buildTypeClasses(props), buildSizeClasses(props), buildShadowClasses(props), buildIconClasses(props), buildLoadingClasses(props));
    const p = {
        id: props.id,
        onClick: (e) => {
            !props.disabled && !props.loading && props.onClick && props.onClick(e);
        },
        disabled: props.disabled || props.loading,
        tabIndex: props.tabIndex,
        title: props.title,
    };
    if (props.href && !props.disabled) {
        return props.download === undefined ? (React.createElement("a", Object.assign({}, p, { className: cx(classes, linkClass), href: props.href, target: props.target }),
            renderIcon(props),
            props.children)) : (React.createElement("a", Object.assign({}, p, { className: cx(classes, linkClass), href: props.href, target: props.target, download: props.download }),
            renderIcon(props),
            props.children));
    }
    else {
        return (React.createElement("button", Object.assign({}, p, { className: cx(classes), type: props.formType }),
            renderIcon(props),
            props.children));
    }
};
Button.defaultProps = {
    formType: "submit",
};
export default Button;
//# sourceMappingURL=button.js.map